// Initialize function that accepts section ID for uniqueness
function initFragranceCarousel(sectionId) {
  const carousel = document.getElementById(`fragrance-carousel-wrapper-${sectionId}`);
  const prevBtn = document.getElementById(`fragrance-prev-btn-${sectionId}`);
  const nextBtn = document.getElementById(`fragrance-next-btn-${sectionId}`);
  const indicatorsContainer = document.getElementById(`fragrance-indicators-${sectionId}`);
  const carouselContainer = document.getElementById(`fragrance-carousel-container-${sectionId}`);
  const sectionElement = document.getElementById(`fragrance-carousel-${sectionId}`);
  
  if (!carousel || !prevBtn || !nextBtn || !indicatorsContainer || !carouselContainer || !sectionElement) {
    console.error('Fragrance carousel elements not found');
    return;
  }
  
  const cards = carousel.querySelectorAll('.fragrance-product-card');
  const totalCards = cards.length;
  const uniqueCards = totalCards / 2;
  
  let currentIndex = 0;
  let cardsPerView = getCardsPerView();
  let autoSlideInterval;
  let isTransitioning = false;
  let autoScrollSpeed = 6000;
  let isAutoplayEnabled = sectionElement.dataset.autoplayEnabled === 'true';

  // Image cache for fast variant switching
  const preloadedImages = new Set();
  const failedImages = new Set();
  
  if (sectionElement.dataset.autoScrollSpeed) {
    autoScrollSpeed = parseInt(sectionElement.dataset.autoScrollSpeed, 10) * 1000;
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenCart = urlParams.get('open_cart') === 'true';
  
  function init() {
    preloadVariantImages();
    createIndicators();
    updateCarousel();
    if (isAutoplayEnabled) {
      startAutoSlide();
    }
    setupCarouselHoverEvents();
    setupVariantTabs();
    setupCardClickHandlers();
    
    if (shouldOpenCart) {
      setTimeout(() => {
        openCartDrawer();
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]open_cart=true/, '').replace(/^&/, '?');
        window.history.replaceState({}, '', newUrl);
      }, 1000);
    }
  }

  function preloadVariantImages() {
    const variantTabs = carousel.querySelectorAll('.fragrance-variant-tab[data-variant-image]');
    const uniqueUrls = new Set();

    variantTabs.forEach(tab => {
      const imageUrl = (tab.dataset.variantImage || '').trim();
      if (imageUrl) {
        uniqueUrls.add(imageUrl);
      }
    });

    uniqueUrls.forEach(url => {
      if (preloadedImages.has(url) || failedImages.has(url)) return;

      const img = new Image();
      img.decoding = 'async';
      img.loading = 'eager';
      img.src = url;

      img.onload = function () {
        preloadedImages.add(url);
      };

      img.onerror = function () {
        failedImages.add(url);
        console.warn('Failed to preload variant image:', url);
      };
    });
  }
  
  function createIndicators() {
    indicatorsContainer.innerHTML = '';
    for (let i = 0; i < uniqueCards; i++) {
      const indicator = document.createElement('div');
      indicator.classList.add('fragrance-indicator');
      if (i === 0) indicator.classList.add('active');
      indicator.addEventListener('click', () => {
        stopAutoSlide();
        goToSlide(i);
        if (isAutoplayEnabled) {
          setTimeout(startAutoSlide, autoScrollSpeed);
        }
      });
      indicatorsContainer.appendChild(indicator);
    }
  }
  
  function getCardsPerView() {
    if (window.innerWidth > 1200) return 3;
    if (window.innerWidth > 768) return 2.5;
    return 1;
  }

  function getSlideWidth() {
    return window.innerWidth > 768 ? cards[0].offsetWidth + 30 : window.innerWidth;
  }
  
  function updateCarousel() {
    if (isTransitioning) return;
    
    const cardWidth = getSlideWidth();
    carousel.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
    
    const indicators = indicatorsContainer.querySelectorAll('.fragrance-indicator');
    indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === currentIndex % uniqueCards);
    });
  }
  
  function goToSlide(index) {
    if (isTransitioning) return;
    currentIndex = index;
    updateCarousel();
  }
  
  function nextSlide() {
    if (isTransitioning) return;
    
    currentIndex++;
    updateCarousel();
    
    if (currentIndex >= uniqueCards) {
      setTimeout(() => {
        isTransitioning = true;
        carousel.style.transition = 'none';
        currentIndex = 0;
        carousel.style.transform = `translateX(0)`;
        
        setTimeout(() => {
          carousel.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
          isTransitioning = false;
        }, 50);
      }, 500);
    }
  }
  
  function prevSlide() {
    if (isTransitioning) return;
    
    if (currentIndex <= 0) {
      isTransitioning = true;
      carousel.style.transition = 'none';
      currentIndex = uniqueCards;
      carousel.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;
      
      setTimeout(() => {
        carousel.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        isTransitioning = false;
        currentIndex--;
        updateCarousel();
      }, 50);
    } else {
      currentIndex--;
      updateCarousel();
    }
  }
  
  function startAutoSlide() {
    if (!isAutoplayEnabled) return;
    stopAutoSlide();
    autoSlideInterval = setInterval(nextSlide, autoScrollSpeed);
  }
  
  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }
  
  function setupCarouselHoverEvents() {
    carouselContainer.addEventListener('mouseenter', stopAutoSlide);
    carouselContainer.addEventListener('mouseleave', () => {
      if (isAutoplayEnabled) {
        startAutoSlide();
      }
    });
  }

  function setProductImageSmooth(productImage, variantImage) {
    if (!productImage || !variantImage) return;

    const currentSrc = productImage.getAttribute('src') || '';
    if (currentSrc === variantImage) return;

    const applyImage = () => {
      productImage.style.opacity = '0.7';

      requestAnimationFrame(() => {
        productImage.src = variantImage;

        const handleLoaded = () => {
          productImage.style.opacity = '1';
          productImage.removeEventListener('load', handleLoaded);
          productImage.removeEventListener('error', handleError);
        };

        const handleError = () => {
          productImage.style.opacity = '1';
          productImage.removeEventListener('load', handleLoaded);
          productImage.removeEventListener('error', handleError);
          console.warn('Failed to apply variant image:', variantImage);
        };

        productImage.addEventListener('load', handleLoaded);
        productImage.addEventListener('error', handleError);

        // If browser already has it cached and marks complete immediately
        if (productImage.complete) {
          productImage.style.opacity = '1';
          productImage.removeEventListener('load', handleLoaded);
          productImage.removeEventListener('error', handleError);
        }
      });
    };

    if (preloadedImages.has(variantImage)) {
      applyImage();
      return;
    }

    if (failedImages.has(variantImage)) {
      console.warn('Variant image previously failed:', variantImage);
      return;
    }

    const img = new Image();
    img.decoding = 'async';
    img.src = variantImage;

    img.onload = function() {
      preloadedImages.add(variantImage);
      applyImage();
    };

    img.onerror = function() {
      failedImages.add(variantImage);
      console.warn('Failed to load variant image:', variantImage);
    };
  }

  function updateCardUI(card, variantData) {
    if (!card) return;

    const {
      variantId,
      variantPrice,
      variantComparePrice,
      variantTitle,
      variantImage
    } = variantData;

    const priceDisplay = card.querySelector('.fragrance-price-display');
    const addToCartBtn = card.querySelector('.fragrance-add-to-cart');
    const buttonPrice = card.querySelector('.fragrance-add-to-cart-price');
    const productImage = card.querySelector('.fragrance-product-image');
    const tabs = card.querySelectorAll('.fragrance-variant-tab');

    tabs.forEach(t => t.classList.remove('active'));
    const activeTab = card.querySelector(`.fragrance-variant-tab[data-variant-id="${variantId}"]`);
    if (activeTab) activeTab.classList.add('active');

    if (priceDisplay) {
      if (variantComparePrice) {
        priceDisplay.innerHTML = `
          <span class="fragrance-compare-price">${variantComparePrice}</span>
          <span class="fragrance-current-price fragrance-sale-price">${variantPrice}</span>
        `;
      } else {
        priceDisplay.innerHTML = `
          <span class="fragrance-current-price">${variantPrice}</span>
        `;
      }
    }

    if (buttonPrice) {
      buttonPrice.textContent = variantPrice;
    }

    if (addToCartBtn) {
      addToCartBtn.dataset.variantId = variantId;
      addToCartBtn.dataset.price = variantPrice;
      addToCartBtn.dataset.comparePrice = variantComparePrice || '';
      addToCartBtn.dataset.variantTitle = variantTitle;
    }

    if (productImage && variantImage) {
      setProductImageSmooth(productImage, variantImage);
    }
  }
  
  function setupVariantTabs() {
    const variantTabContainers = carousel.querySelectorAll('.fragrance-variant-tab-container');
    
    variantTabContainers.forEach(container => {
      const tabs = container.querySelectorAll('.fragrance-variant-tab');
      
      tabs.forEach(tab => {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const card = this.closest('.fragrance-product-card');
          if (!card) return;

          const variantData = {
            variantId: this.dataset.variantId,
            variantPrice: this.dataset.variantPrice,
            variantComparePrice: this.dataset.variantComparePrice,
            variantTitle: this.dataset.variantTitle,
            variantImage: this.dataset.variantImage || ''
          };

          updateCardUI(card, variantData);

          this.style.transform = 'scale(0.95)';
          setTimeout(() => {
            this.style.transform = '';
          }, 150);
        });
      });
    });
  }
  
  function setupCardClickHandlers() {
    cards.forEach(card => {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.fragrance-add-to-cart') || 
            e.target.closest('.fragrance-variant-tab')) {
          return;
        }
        
        const productLink = card.querySelector('.fragrance-product-link');
        if (productLink && productLink.href) {
          window.location.href = productLink.href;
        }
      });
      
      card.style.cursor = 'pointer';
    });
  }
  
  prevBtn.addEventListener('click', () => {
    stopAutoSlide();
    prevSlide();
    if (isAutoplayEnabled) {
      setTimeout(startAutoSlide, autoScrollSpeed);
    }
  });
  
  nextBtn.addEventListener('click', () => {
    stopAutoSlide();
    nextSlide();
    if (isAutoplayEnabled) {
      setTimeout(startAutoSlide, autoScrollSpeed);
    }
  });
  
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      cardsPerView = getCardsPerView();
      updateCarousel();
    }, 250);
  });
  
  let touchStartX = 0;
  let touchEndX = 0;
  
  carousel.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoSlide();
  });
  
  carousel.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
    if (isAutoplayEnabled) {
      setTimeout(startAutoSlide, autoScrollSpeed);
    }
  });
  
  function handleSwipe() {
    const swipeThreshold = 50;
    if (touchEndX < touchStartX - swipeThreshold) {
      nextSlide();
    }
    if (touchEndX > touchStartX + swipeThreshold) {
      prevSlide();
    }
  }
  
  const addToCartButtons = Array.from(carousel.querySelectorAll('.fragrance-add-to-cart')).slice(0, uniqueCards);
  let isAddingToCart = false;
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (this.dataset.processing === 'true' || isAddingToCart) {
        return;
      }
      
      this.dataset.processing = 'true';
      isAddingToCart = true;
      
      const productId = this.dataset.productId;
      const variantId = this.dataset.variantId;
      const variantTitle = this.dataset.variantTitle;
      const price = this.dataset.price;
      const productName = this.parentElement.querySelector('.fragrance-product-name').textContent;
      const card = this.closest('.fragrance-product-card');
      const buttonText = this.querySelector('.fragrance-add-to-cart-text');
      const buttonPriceContainer = this.querySelector('.fragrance-button-price');
      const originalButtonText = buttonText.textContent;
      const originalButtonPrice = buttonPriceContainer.innerHTML;
      
      const isViewProduct = this.dataset.viewProduct === 'true';
      const isDiscoveryPack = card.dataset.isDiscoveryPack === 'true';
      
      if (isViewProduct || isDiscoveryPack) {
        this.dataset.processing = 'false';
        isAddingToCart = false;
        return;
      }
      
      const ripple = document.createElement('span');
      ripple.style.position = 'absolute';
      ripple.style.width = '20px';
      ripple.style.height = '20px';
      ripple.style.background = 'rgba(255, 255, 255, 0.5)';
      ripple.style.borderRadius = '50%';
      ripple.style.transform = 'translate(-50%, -50%)';
      ripple.style.pointerEvents = 'none';
      ripple.style.animation = 'fragrance-rippleEffect 0.6s ease-out';
      
      const rect = this.getBoundingClientRect();
      ripple.style.left = (e.clientX - rect.left) + 'px';
      ripple.style.top = (e.clientY - rect.top) + 'px';
      
      this.style.position = 'relative';
      this.appendChild(ripple);
      
      if (productId && variantId) {
        addToCartShopify(variantId, 1, this);
      } else {
        buttonText.textContent = '✓ ADDED';
        buttonPriceContainer.style.display = 'none';
        this.style.background = 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)';
        card.style.animation = 'fragrance-bounce 0.5s ease';
        
        setTimeout(() => {
          buttonText.textContent = originalButtonText;
          buttonPriceContainer.style.display = '';
          buttonPriceContainer.innerHTML = originalButtonPrice;
          this.style.background = '';
          ripple.remove();
          card.style.animation = '';
          this.dataset.processing = 'false';
          isAddingToCart = false;
          refreshPageAndOpenCart();
        }, 2000);
      }
      
      console.log(`Added ${productName} (${variantTitle}) to cart for ${price}`);
    });
  });
  
  function addToCartShopify(variantId, quantity, button) {
    const buttonText = button.querySelector('.fragrance-add-to-cart-text');
    const buttonPriceContainer = button.querySelector('.fragrance-button-price');
    const originalButtonText = buttonText.textContent;
    const originalButtonPrice = buttonPriceContainer.innerHTML;
    const card = button.closest('.fragrance-product-card');
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(() => {
      buttonText.textContent = '✓ ADDED';
      buttonPriceContainer.style.display = 'none';
      button.style.background = 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)';
      card.style.animation = 'fragrance-bounce 0.5s ease';
      
      showNotification('Product added to cart successfully!');
      updateCartCount();
      
      setTimeout(() => {
        buttonText.textContent = originalButtonText;
        buttonPriceContainer.style.display = '';
        buttonPriceContainer.innerHTML = originalButtonPrice;
        button.style.background = '';
        card.style.animation = '';
        button.dataset.processing = 'false';
        isAddingToCart = false;
        refreshPageAndOpenCart();
      }, 1500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      buttonText.textContent = 'ERROR';
      showNotification('Error adding product to cart. Please try again.', 'error');
      setTimeout(() => {
        buttonText.textContent = originalButtonText;
        button.dataset.processing = 'false';
        isAddingToCart = false;
      }, 2000);
    });
  }
  
  function refreshPageAndOpenCart() {
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('open_cart', 'true');
    window.location.href = currentUrl.toString();
  }
  
  function openCartDrawer() {
    if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
      window.theme.cartDrawer.open();
      return;
    }
    
    const cartTriggers = [
      '.cart-drawer-trigger',
      '.js-drawer-open-right',
      '.js-drawer-open',
      '[data-drawer-toggle]',
      '.site-header__cart',
      '.cart-icon',
      '#cart-icon-bubble',
      '.cart-count-bubble'
    ];
    
    for (const selector of cartTriggers) {
      const trigger = document.querySelector(selector);
      if (trigger) {
        trigger.click();
        return;
      }
    }
    
    const cartDrawers = [
      '#cart-drawer',
      '.cart-drawer',
      '.drawer--right',
      '.ajaxcart',
      '.mini-cart',
      '[data-cart-drawer]'
    ];
    
    for (const selector of cartDrawers) {
      const drawer = document.querySelector(selector);
      if (drawer) {
        drawer.classList.add('active', 'open', 'is-open', 'drawer--open');
        
        const closeBtn = drawer.querySelector('.drawer__close, .js-drawer-close, [data-drawer-toggle]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            drawer.classList.remove('active', 'open', 'is-open', 'drawer--open');
          });
        }
        return;
      }
    }
    
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.instances) {
      const instances = window.Shopify.theme.sections.instances;
      Object.keys(instances).forEach(key => {
        const instance = instances[key];
        if (!instance) return;
        
        if (instance.type === 'cart-drawer' || instance.type === 'cart' || instance.type === 'header') {
          if (instance.cart && typeof instance.cart.open === 'function') {
            instance.cart.open();
          } else if (typeof instance.open === 'function') {
            instance.open();
          }
        }
      });
      return;
    }
    
    if (window.location.pathname === '/cart') {
      return;
    }
    
    console.log('Could not open cart drawer, redirecting to cart page');
    window.location.href = '/cart';
  }
  
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count, .cart-item-count, .cart-count-bubble, .site-header__cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
  
  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `fragrance-notification fragrance-notification-${type}`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        if (document.body.contains(notification)) {
          document.body.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }


   // Add bounce animation and price display styles
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fragrance-bounce {
      0%, 100% { transform: translateY(0) scale(1); }
      25% { transform: translateY(-5px) scale(1.02); }
      50% { transform: translateY(0) scale(1); }
      75% { transform: translateY(-2px) scale(1.01); }
    }
    
    @keyframes fragrance-rippleEffect {
      to {
        width: 200px;
        height: 200px;
        opacity: 0;
      }
    }
    
    .fragrance-price-display {
      display: flex;
      align-items: center;
      // justify-content: center;
      gap: 8px;
      margin: 5px 0;
      min-height: 24px;
    }
    
    .fragrance-current-price {
      font-weight: 600;
      font-size: 1.1em;
      color: var(--fragrance-text-color);
    }
    
    .fragrance-sale-price {
      // color: #ff4d4f;
      color: #E63946;
    }
    
    .fragrance-compare-price {
      color: #55555;
      text-decoration: line-through;
      font-size: 0.9em;
      order: -1; /* Ensures compare price is visually first */
    }
    
    .fragrance-add-to-cart {
      display: flex;
      flex-direction: row; /* Changed to row */
      align-items: center;
      justify-content: space-between; /* Pushes text and price to opposite ends */
      width: 100%;
      padding: 12px 20px;
      background: linear-gradient(135deg, var(--fragrance-primary-color), var(--fragrance-secondary-color));
      color: white;
      border: none;
      border-radius: 25px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-size: 0.8em;
      position: relative;
      overflow: hidden;
    }
    
    .fragrance-add-to-cart:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0,0,0,0.2);
    }
    
    .fragrance-button-price {
      display: flex;
      align-items: center;
      font-size: 0.9em;
      font-weight: 700;
    }
    
    .fragrance-add-to-cart-text {
      font-weight: 600;
      white-space: nowrap;
    }
    
    /* New styles for product image transitions */
    .fragrance-product-image {
      transition: opacity 0.3s ease;
    }
  `;
  document.head.appendChild(style);
  
  // Initialize the carousel
  init();
}